var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/Switch",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.537297,13.8164796 L16.2234576,13.1685693 L12.5184928,9.24671192 L8.78345454,13.1646168 L9.50052112,13.821579 L12.0201416,11.1948796 L12.0201416,23.0203589 L13.0201416,23.0203589 L13.0201416,11.196194 L15.537297,13.8164796 Z",
    id: "Bottom-Arrow",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(12.500000, 16.020359) rotate(90.000000) translate(-12.500000, -16.020359) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.537297,5.81647958 L15.2234576,5.1685693 L11.5184928,1.24671192 L7.78345454,5.16461677 L8.50052112,5.82157899 L11.0201416,3.19487959 L11.0201416,15.0203589 L12.0201416,15.0203589 L12.0201416,3.19619397 L14.537297,5.81647958 Z",
    id: "Top-Arrow",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(11.500000, 8.020359) rotate(-90.000000) translate(-11.500000, -8.020359) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlSwitch);
export default __webpack_public_path__ + "static/media/controlSwitch.ecf17682abe8aef9e934c46d16939845.svg";
export { ForwardRef as ReactComponent };